import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandHeader from "../components/BrandHeader";
import Footer from "../components/Footer";

export default function Impressum() {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="impressum-page">
      <BrandHeader />

      <main className="flex-1">
        <section className="bp-container py-16 sm:py-24 max-w-3xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#0A2540] transition-colors mb-10"
            data-testid="impressum-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>

          <h1 className="bp-h1 mb-8">Impressum</h1>

          <div className="space-y-10 text-slate-700">
            <section>
              <h2 className="bp-h3 mb-3">Information according to § 5 TMG</h2>
              <p className="bp-body">
                Build Partner
                <br />
                White-label development services
              </p>
            </section>

            <section>
              <h2 className="bp-h3 mb-3">Contact</h2>
              <p className="bp-body">
                Email:{" "}
                <a
                  href="mailto:hello@build-partner.de"
                  className="text-[#0A2540] underline underline-offset-4 hover:text-[#051626]"
                  data-testid="impressum-email-link"
                >
                  hello@build-partner.de
                </a>
              </p>
            </section>

            <section>
              <h2 className="bp-h3 mb-3">Responsible for content</h2>
              <p className="bp-body">
                The operator of this site is responsible for its own content
                made available for use in accordance with general laws under § 7
                Abs.1 TMG.
              </p>
            </section>

            <section>
              <h2 className="bp-h3 mb-3">Liability for links</h2>
              <p className="bp-body">
                Our offer contains links to external websites of third parties,
                on whose contents we have no influence. Therefore, we cannot
                assume any liability for these external contents. The respective
                provider or operator of the linked pages is always responsible
                for the contents.
              </p>
            </section>

            <section>
              <h2 className="bp-h3 mb-3">Copyright</h2>
              <p className="bp-body">
                The contents and works on these pages created by the site
                operator are subject to copyright law. Duplication, processing,
                distribution, or any form of commercialization of such material
                beyond the scope of copyright law shall require the prior
                written consent of its respective author or creator.
              </p>
            </section>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
